import pdfMake from "pdfmake/build/pdfmake";
import * as pdfFonts from "pdfmake/build/vfs_fonts";

interface ReportTitle {
  text?: any;
  fontSize?: number;
  bold?: boolean;
  style?: any;
  table?: any;
  image?: any;
  margin?: [number, number, number, number];
  border?: [boolean, boolean, boolean, boolean];
}

interface Interface {
  DataTests: any;
  NameUser?: any;
  selectedJourney?: any;
  t?: any;
  getBarGraphImg?: any;
  getTableSmartImg?: any;
}
export default function ClientsPdf({
  DataTests,
  NameUser,
  selectedJourney,
  t,
}: Interface) {
  pdfMake.vfs = pdfFonts.vfs;
  let _selectedJourney = 1;
  if (selectedJourney !== "undefined") _selectedJourney = selectedJourney;
  const dataIaFinish = new Date(DataTests[_selectedJourney].date_IA_finish);
  const dataIaFinishFormated = dataIaFinish.toLocaleDateString("pt-BR");
  let dateFristAvaliation = ""
  let dateSecondAvaliation = ""
  try {
    dateFristAvaliation = new Date(DataTests[_selectedJourney].avaliation[0].date_created).toLocaleDateString("pt-BR") || "";
    dateSecondAvaliation = new Date(DataTests[_selectedJourney].reavaliation[0].date_created).toLocaleDateString("pt-BR") || "";
  } catch {
    dateFristAvaliation = "";
    dateSecondAvaliation = "";
  }

  const dataIaStart = new Date(DataTests[_selectedJourney].date_IA_start);
  const dataIaStartFormated = dataIaStart.toLocaleDateString("pt-BR");

  const logoNosso =
    "data:image/png;base64,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";

  const calcEvolution = (a: any, b: any, multiply: number, format: number) => {
    const calc = a - b > 0 ? ((a - b) * multiply).toFixed(format) + "%" : "-";
    return calc;
  };

  const calcEvolutionColor = (a: any, b: any) => {
    const evolutuinColor = a - b <= 0 ? null : "#24660a";
    return evolutuinColor;
  };

  const calcGeneralColor = (color: any) => {
    const colorItem =
      color === "red"
        ? "#d6373a"
        : color === "green"
          ? "#24660a"
          : color === "yellow"
            ? "#c5a82f"
            : null;
    return colorItem;
  };
  const amtPlays =
    DataTests[_selectedJourney] &&
      DataTests[_selectedJourney]["amt_plays"] &&
      DataTests[_selectedJourney]["amt_plays"][_selectedJourney]
      ? DataTests[_selectedJourney]["amt_plays"][_selectedJourney]
      : 0;
  const reportTitle: ReportTitle[] = [
    {
      style: "tableExample",
      table: {
        widths: [130, "*"],
        body: [
          [
            {
              image: logoNosso,
              width: 115,
            },
            NameUser +
            "\n" +
            t("global.training_period") +
            dataIaStartFormated +
            " à " +
            dataIaFinishFormated +
            "\n" +
            t("global.number_of_moves") +
            amtPlays,
          ],
        ],
      },
    },
  ];

  const bodyTitle = [
    {
      text: t("global.test").toUpperCase(),
      style: "tableHeader",
      rowSpan: 2,
      alignment: "center",
      fontSize: 10,
      fillColor: "#e8faff",
      border: [false, false, false, false],
      bold: true,
    },

    {
      text: t("global.stage_1_title").toUpperCase() + "\n" + `(${dateFristAvaliation})`,
      style: "tableHeader",
      alignment: "center",
      colSpan: 2,
      fontSize: 10,
      fillColor: "#e8faff",
      border: [false, false, false, false],
      bold: true,
    },
    {},
    {
      text: t("global.stage_3_title").toUpperCase() + "\n" + `(${dateSecondAvaliation})`,
      style: "tableHeader",
      alignment: "center",
      colSpan: 2,
      fontSize: 10,
      fillColor: "#e8faff",
      border: [false, false, false, false],
      bold: true,
    },
    {},
    {
      text: t("global.evolution_in").toUpperCase(),
      style: "tableHeader",
      alignment: "center",
      colSpan: 1,
      fontSize: 10,
      fillColor: "#e8faff",
      border: [false, false, false, false],
      bold: true,
    },
  ];

  const bodySubTitle = [
    {
      text: "Header 1",
      style: "tableHeader",
      alignment: "center",
      fontSize: 8,
      fillColor: "#e8faff",
      border: [false, false, false, false],
      bold: true,
    },
    {
      text: t("global.score").toUpperCase(),
      style: "tableHeader",
      alignment: "center",
      fontSize: 8,
      fillColor: "#e8faff",
      border: [false, false, false, false],
      bold: true,
    },
    {
      text: t("global.time_table").toUpperCase(),
      style: "tableHeader",
      alignment: "center",
      fontSize: 8,
      fillColor: "#e8faff",
      border: [false, false, false, false],
      bold: true,
    },
    {
      text: t("global.score").toUpperCase(),
      style: "tableHeader",
      alignment: "center",
      fontSize: 8,
      fillColor: "#e8faff",
      border: [false, false, false, false],
      bold: true,
    },
    {
      text: t("global.time_table").toUpperCase(),
      style: "tableHeader",
      alignment: "center",
      fontSize: 8,
      fillColor: "#e8faff",
      border: [false, false, false, false],
      bold: true,
    },
    {
      text: t("global.pontuation").toUpperCase(),
      style: "tableHeader",
      alignment: "center",
      colSpan: 1,
      fontSize: 10,
      fillColor: "#e8faff",
      border: [false, false, false, false],
      bold: true,
    },
  ];
  const tablePageOne: any = DataTests[_selectedJourney].avaliation.map(
    (desc: any, indice: any) => {
      const reav = DataTests[_selectedJourney].reavaliation[indice];
      return [
        {
          text: t(`tests.${desc.test_name}`),
          fontSize: 10,
          bold: true,
          margin: [0, 5, 0, 5],
        },
        {
          text: desc.test_score * 10 + "%",
          color: calcGeneralColor(desc.color),
          bold: true,
          alignment: "center",
          fontSize: 10,
          margin: [0, 5, 0, 5],
        },
        {
          text: desc.test_time,
          alignment: "center",
          fontSize: 10,
          margin: [0, 5, 0, 5],
        },
        {
          text: reav.test_score * 10 + "%",
          color: calcGeneralColor(reav.color),
          alignment: "center",
          fontSize: 10,
          margin: [0, 5, 0, 5],
          bold: true,
        },
        {
          text: reav.test_time,
          alignment: "center",
          fontSize: 10,
          margin: [0, 5, 0, 5],
        },
        {
          text: calcEvolution(reav.test_score, desc.test_score, 10, 0),
          alignment: "center",
          fontSize: 10,
          margin: [0, 5, 0, 5],
          bold: true,
          color: `${reav.test_score - desc.test_score <= 0 ? null : "#24660a"}`,
        },
      ];
    }
  );
  const tablePageTwo: any =
    DataTests[_selectedJourney]?.evolution !== undefined
      ? DataTests[_selectedJourney]?.evolution?.map((desc: any) => {
        return [
          {
            text: t(`tests.${desc.test_name}`),
            fontSize: 10,
            bold: true,
            margin: [0, 5, 0, 5],
          },
          {
            text: desc.score_avaliation * 10 + "%",
            color: calcGeneralColor(desc.color_avaliation),
            bold: true,
            alignment: "center",
            fontSize: 10,
            margin: [0, 5, 0, 5],
          },
          {
            text: desc.time_avaliation,
            alignment: "center",
            fontSize: 10,
            margin: [0, 5, 0, 5],
          },
          {
            text: desc.score_reavaliation * 10 + "%",
            color: calcGeneralColor(desc.color_reavaliation),
            alignment: "center",
            fontSize: 10,
            margin: [0, 5, 0, 5],
            bold: true,
          },
          {
            text: desc.reavaliation_time,
            alignment: "center",
            fontSize: 10,
            margin: [0, 5, 0, 5],
          },
          {
            text: calcEvolution(
              desc.score_reavaliation,
              desc.score_avaliation,
              10,
              0
            ),
            alignment: "center",
            fontSize: 10,
            margin: [0, 5, 0, 5],
            bold: true,
            color: calcEvolutionColor(
              desc.score_reavaliation,
              desc.test_score
            ),
          },
        ];
      })
      : [];

  const tablePageThree: any =
    DataTests[_selectedJourney]?.involution !== undefined
      ? DataTests[_selectedJourney].involution?.map((desc: any) => {
        return [
          {
            text: t(`tests.${desc.test_name}`),
            fontSize: 10,
            bold: true,
            margin: [0, 5, 0, 5],
          },
          {
            text: desc.score_avaliation * 10 + "%",
            color: calcGeneralColor(desc.color_avaliation),
            bold: true,
            alignment: "center",
            fontSize: 10,
            margin: [0, 5, 0, 5],
          },
          {
            text: desc.time_avaliation,
            alignment: "center",
            fontSize: 10,
            margin: [0, 5, 0, 5],
          },
          {
            text: desc.score_reavaliation * 10 + "%",
            color: calcGeneralColor(desc.color_reavaliation),
            alignment: "center",
            fontSize: 10,
            margin: [0, 5, 0, 5],
            bold: true,
          },
          {
            text: desc.reavaliation_time,
            alignment: "center",
            fontSize: 10,
            margin: [0, 5, 0, 5],
          },
          {
            text: calcEvolution(
              desc.score_reavaliation,
              desc.score_avaliation,
              10,
              0
            ),
            alignment: "center",
            fontSize: 10,
            margin: [0, 5, 0, 5],
            bold: true,
            color: calcEvolutionColor(
              desc.score_reavaliation,
              desc.score_avaliation
            ),
          },
        ];
      })
      : [];

  const tablePageFor: any =
    DataTests[_selectedJourney]?.can_improve !== undefined
      ? DataTests[_selectedJourney].can_improve.map((desc: any) => {
        return [
          {
            text: t(`tests.${desc.test_name}`),
            fontSize: 10,
            bold: true,
            margin: [0, 5, 0, 5],
          },
          {
            text: desc.score_avaliation * 10 + "%",
            color: calcGeneralColor(desc.color_avaliation),
            bold: true,
            alignment: "center",
            fontSize: 10,
            margin: [0, 5, 0, 5],
          },
          {
            text: desc.time_avaliation,
            alignment: "center",
            fontSize: 10,
            margin: [0, 5, 0, 5],
          },
          {
            text: desc.score_reavaliation * 10 + "%",
            color: calcGeneralColor(desc.color_reavaliation),
            alignment: "center",
            fontSize: 10,
            margin: [0, 5, 0, 5],
            bold: true,
          },
          {
            text: desc.reavaliation_time,
            alignment: "center",
            fontSize: 10,
            margin: [0, 5, 0, 5],
          },
          {
            text: calcEvolution(
              desc.score_reavaliation,
              desc.score_avaliation,
              10,
              0
            ),
            alignment: "center",
            fontSize: 10,
            margin: [0, 5, 0, 5],
            bold: true,
            color: calcEvolutionColor(
              desc.score_reavaliation,
              desc.score_avaliation
            ),
          },
        ];
      })
      : [];

  const graphicPageOne: any = [];
  const graphicPageTwo: any = [];
  const graphicPageThree: any = [];
  const graphicPageFor: any = [];

  for (let i = 0; i < tablePageOne.length; i++) {
    const item = tablePageOne[i];
    graphicPageOne.push(item);
  }
  for (let i = 0; i < tablePageTwo.length; i++) {
    const item = tablePageTwo[i];
    graphicPageTwo.push(item);
  }
  for (let i = 0; i < tablePageThree.length; i++) {
    const item = tablePageThree[i];
    graphicPageThree.push(item);
  }
  for (let i = 0; i < tablePageFor.length; i++) {
    const item = tablePageFor[i];
    graphicPageFor.push(item);
  }

  const pageOne: any = [
    {
      text: [
        t("global.hello") + "\n\n",
        t("global.report_page_one_text_01") + "\n",
        t("global.report_page_one_text_02") + "\n",
        t("global.report_page_one_text_03") + "\n\n",
      ],
      fontSize: 10,
    },
    {
      style: "tableExample",
      color: "#444",

      table: {
        widths: [180, 55, 55, 55, 55, 90],
        headerRows: 2,
        body: [bodyTitle, bodySubTitle, ...graphicPageOne],
      },
      layout: {
        fillColor: function (rowIndex: any) {
          return rowIndex % 2 === 0 ? null : "#dee2e6";
        },
        defaultBorder: false,
        alignment: "center",
      },
    },
    {
      text: [{ text: "\n" }],
    },
    {
      style: "tableExample",
      table: {
        widths: [20, 175, 20, 175, 20, 175],
        heights: 0,
        body: [
          [
            {
              fillColor: "#6faf56",
              margin: [0, 0, 0, 0],
              text: "",
            },
            {
              text: t("global.adequate"),
              color: "#444",
              margin: [0, 0, 0, 0],
              fontSize: 10,
            },
            {
              fillColor: "#eed05a",
              margin: [0, 0, 0, 0],
              text: "",
            },
            {
              text: t("global.improvement_opportunity"),
              color: "#444",
              margin: [0, 0, 0, 0],
              fontSize: 10,
            },
            {
              fillColor: "#f75b5d",
              margin: [0, 0, 0, 0],
              text: "",
            },
            {
              text: t("global.attention_point"),
              margin: [0, 0, 0, 0],
              color: "#444",
              fontSize: 10,
            },
          ],
        ],
      },
      layout: {
        defaultBorder: false,
      },
      pageBreak: "after",
    },
  ];

  const pageTwo: any = [
    {
      text: [{ text: "Sua Evolução" + "\n\n", fontSize: 14, bold: true }],
    },
    {
      style: "tableExample",
      color: "#444",

      table: {
        widths: [180, 55, 55, 55, 55, 90],
        headerRows: 2,
        body: [
          [
            {
              text: t("global.test").toUpperCase(),
              style: "tableHeader",
              rowSpan: 2,
              alignment: "center",
              fontSize: 10,
              fillColor: "#e8faff",
              border: [false, false, false, false],
              bold: true,
            },

            {
              text: t("global.stage_1_title").toUpperCase(),
              style: "tableHeader",
              alignment: "center",
              colSpan: 2,
              fontSize: 10,
              fillColor: "#e8faff",
              border: [false, false, false, false],
              bold: true,
            },
            {},
            {
              text: t("global.stage_3_title").toUpperCase(),
              style: "tableHeader",
              alignment: "center",
              colSpan: 2,
              fontSize: 10,
              fillColor: "#e8faff",
              border: [false, false, false, false],
              bold: true,
            },
            {},
            {
              text: t("global.evolution_in").toUpperCase(),
              style: "tableHeader",
              alignment: "center",
              colSpan: 1,
              fontSize: 10,
              fillColor: "#e8faff",
              border: [false, false, false, false],
              bold: true,
            },
          ],
          [
            {
              text: "Header 1",
              style: "tableHeader",
              alignment: "center",
              fontSize: 8,
              fillColor: "#e8faff",
              border: [false, false, false, false],
              bold: true,
            },
            {
              text: t("global.score").toUpperCase(),
              style: "tableHeader",
              alignment: "center",
              fontSize: 8,
              fillColor: "#e8faff",
              border: [false, false, false, false],
              bold: true,
            },
            {
              text: t("global.time_table").toUpperCase(),
              style: "tableHeader",
              alignment: "center",
              fontSize: 8,
              fillColor: "#e8faff",
              border: [false, false, false, false],
              bold: true,
            },
            {
              text: t("global.score").toUpperCase(),
              style: "tableHeader",
              alignment: "center",
              fontSize: 8,
              fillColor: "#e8faff",
              border: [false, false, false, false],
              bold: true,
            },
            {
              text: t("global.time_table").toUpperCase(),
              style: "tableHeader",
              alignment: "center",
              fontSize: 8,
              fillColor: "#e8faff",
              border: [false, false, false, false],
              bold: true,
            },
            {
              text: t("global.pontuation").toUpperCase(),
              style: "tableHeader",
              alignment: "center",
              colSpan: 1,
              fontSize: 10,
              fillColor: "#e8faff",
              border: [false, false, false, false],
              bold: true,
            },
          ],
          ...graphicPageTwo,
        ],
      },
      layout: {
        fillColor: function (rowIndex: any) {
          return rowIndex % 2 === 0 ? null : "#dee2e6";
        },
        defaultBorder: false,
        alignment: "center",
      },
    },
    {
      text: [{ text: "\n" }],
    },
    {
      style: "tableExample",
      table: {
        widths: [20, 175, 20, 175, 20, 175],
        heights: 0,
        body: [
          [
            {
              fillColor: "#6faf56",
              margin: [0, 0, 0, 0],
              text: "",
            },
            {
              text: t("global.adequate"),
              color: "#444",
              margin: [0, 0, 0, 0],
              fontSize: 10,
            },
            {
              fillColor: "#eed05a",
              margin: [0, 0, 0, 0],
              text: "",
            },
            {
              text: t("global.improvement_opportunity"),
              color: "#444",
              margin: [0, 0, 0, 0],
              fontSize: 10,
            },
            {
              fillColor: "#f75b5d",
              margin: [0, 0, 0, 0],
              text: "",
            },
            {
              text: t("global.attention_point"),
              margin: [0, 0, 0, 0],
              color: "#444",
              fontSize: 10,
            },
          ],
        ],
      },
      layout: {
        defaultBorder: false,
      },
    },
    {
      text: [
        {
          text: "\n\n" + t("global.report_page_two_text_01") + "\n\n",
          fontSize: 10,
        },
        {
          text: DataTests[_selectedJourney].evolution_description.map(
            (desc: any) => {
              return {
                text: [
                  {
                    text: t(`tests.${desc}`) + "\n",
                    fontSize: 10,
                    bold: true,
                  },
                  {
                    text: t(`tests.${desc}_descricao`) + "\n\n",
                    fontSize: 9,
                  },
                ],
              };
            }
          ),
        },
      ],
      pageBreak: "after",
    },
  ];
  const pageThree: any = [
    {
      text: [
        {
          text: t("global.attention_points") + "\n\n",
          fontSize: 14,
          bold: true,
        },
      ],
    },
    {
      style: "tableExample",
      color: "#444",

      table: {
        widths: [180, 55, 55, 55, 55, 90],
        headerRows: 2,
        body: [
          [
            {
              text: t("global.test").toUpperCase(),
              style: "tableHeader",
              rowSpan: 2,
              alignment: "center",
              fontSize: 10,
              fillColor: "#e8faff",
              border: [false, false, false, false],
              bold: true,
            },

            {
              text: t("global.stage_1_title").toUpperCase(),
              style: "tableHeader",
              alignment: "center",
              colSpan: 2,
              fontSize: 10,
              fillColor: "#e8faff",
              border: [false, false, false, false],
              bold: true,
            },
            {},
            {
              text: t("global.stage_3_title").toUpperCase(),
              style: "tableHeader",
              alignment: "center",
              colSpan: 2,
              fontSize: 10,
              fillColor: "#e8faff",
              border: [false, false, false, false],
              bold: true,
            },
            {},
            {
              text: t("global.evolution_in").toUpperCase(),
              style: "tableHeader",
              alignment: "center",
              colSpan: 1,
              fontSize: 10,
              fillColor: "#e8faff",
              border: [false, false, false, false],
              bold: true,
            },
          ],
          [
            {
              text: "Header 1",
              style: "tableHeader",
              alignment: "center",
              fontSize: 8,
              fillColor: "#e8faff",
              border: [false, false, false, false],
              bold: true,
            },
            {
              text: t("global.score").toUpperCase(),
              style: "tableHeader",
              alignment: "center",
              fontSize: 8,
              fillColor: "#e8faff",
              border: [false, false, false, false],
              bold: true,
            },
            {
              text: t("global.time_table").toUpperCase(),
              style: "tableHeader",
              alignment: "center",
              fontSize: 8,
              fillColor: "#e8faff",
              border: [false, false, false, false],
              bold: true,
            },
            {
              text: t("global.score").toUpperCase(),
              style: "tableHeader",
              alignment: "center",
              fontSize: 8,
              fillColor: "#e8faff",
              border: [false, false, false, false],
              bold: true,
            },
            {
              text: t("global.time_table").toUpperCase(),
              style: "tableHeader",
              alignment: "center",
              fontSize: 8,
              fillColor: "#e8faff",
              border: [false, false, false, false],
              bold: true,
            },
            {
              text: t("global.pontuation").toUpperCase(),
              style: "tableHeader",
              alignment: "center",
              colSpan: 1,
              fontSize: 10,
              fillColor: "#e8faff",
              border: [false, false, false, false],
              bold: true,
            },
          ],

          ...graphicPageThree,
        ],
      },
      layout: {
        fillColor: function (rowIndex: any) {
          return rowIndex % 2 === 0 ? null : "#dee2e6";
        },
        defaultBorder: false,
        alignment: "center",
      },
    },
    {
      text: [{ text: "\n" }],
    },
    {
      style: "tableExample",
      table: {
        widths: [20, 175, 20, 175, 20, 175],
        heights: 0,
        body: [
          [
            {
              fillColor: "#6faf56",
              margin: [0, 0, 0, 0],
              text: "",
            },
            {
              text: t("global.adequate"),
              color: "#444",
              margin: [0, 0, 0, 0],
              fontSize: 10,
            },
            {
              fillColor: "#eed05a",
              margin: [0, 0, 0, 0],
              text: "",
            },
            {
              text: t("global.improvement_opportunity"),
              color: "#444",
              margin: [0, 0, 0, 0],
              fontSize: 10,
            },
            {
              fillColor: "#f75b5d",
              margin: [0, 0, 0, 0],
              text: "",
            },
            {
              text: t("global.attention_point"),
              margin: [0, 0, 0, 0],
              color: "#444",
              fontSize: 10,
            },
          ],
        ],
      },
      layout: {
        defaultBorder: false,
      },
    },
    {
      text: [
        {
          text: "\n\n" + t("global.report_page_three_text_01") + "\n\n",
          fontSize: 10,
        },
        {
          text: DataTests[_selectedJourney].involution_description.map(
            (desc: any) => {
              return {
                text: [
                  {
                    text: t(`tests.${desc}`) + "\n",
                    fontSize: 10,
                    bold: true,
                  },
                  {
                    text: t(`tests.${desc}_descricao`) + "\n\n",
                    fontSize: 9,
                  },
                ],
              };
            }
          ),
        },
      ],
      pageBreak: "after",
    },
  ];
  const pageFor: any = [
    {
      text: [
        {
          text: t("global.improvement_opportunities") + "\n\n",
          fontSize: 14,
          bold: true,
        },
      ],
      style: "subheader",
    },
    {
      style: "tableExample",
      color: "#444",

      table: {
        widths: [180, 55, 55, 55, 55, 90],
        headerRows: 2,
        body: [
          [
            {
              text: t("global.test").toUpperCase(),
              style: "tableHeader",
              rowSpan: 2,
              alignment: "center",
              fontSize: 10,
              fillColor: "#e8faff",
              border: [false, false, false, false],
              bold: true,
            },

            {
              text: t("global.stage_1_title").toUpperCase(),
              style: "tableHeader",
              alignment: "center",
              colSpan: 2,
              fontSize: 10,
              fillColor: "#e8faff",
              border: [false, false, false, false],
              bold: true,
            },
            {},
            {
              text: t("global.stage_3_title").toUpperCase(),
              style: "tableHeader",
              alignment: "center",
              colSpan: 2,
              fontSize: 10,
              fillColor: "#e8faff",
              border: [false, false, false, false],
              bold: true,
            },
            {},
            {
              text: t("global.evolution_in").toUpperCase(),
              style: "tableHeader",
              alignment: "center",
              colSpan: 1,
              fontSize: 10,
              fillColor: "#e8faff",
              border: [false, false, false, false],
              bold: true,
            },
          ],
          [
            {
              text: "Header 1",
              style: "tableHeader",
              alignment: "center",
              fontSize: 8,
              fillColor: "#e8faff",
              border: [false, false, false, false],
              bold: true,
            },
            {
              text: t("global.score").toUpperCase(),
              style: "tableHeader",
              alignment: "center",
              fontSize: 8,
              fillColor: "#e8faff",
              border: [false, false, false, false],
              bold: true,
            },
            {
              text: t("global.time_table").toUpperCase(),
              style: "tableHeader",
              alignment: "center",
              fontSize: 8,
              fillColor: "#e8faff",
              border: [false, false, false, false],
              bold: true,
            },
            {
              text: t("global.score").toUpperCase(),
              style: "tableHeader",
              alignment: "center",
              fontSize: 8,
              fillColor: "#e8faff",
              border: [false, false, false, false],
              bold: true,
            },
            {
              text: t("global.time_table").toUpperCase(),
              style: "tableHeader",
              alignment: "center",
              fontSize: 8,
              fillColor: "#e8faff",
              border: [false, false, false, false],
              bold: true,
            },
            {
              text: t("global.pontuation").toUpperCase(),
              style: "tableHeader",
              alignment: "center",
              colSpan: 1,
              fontSize: 10,
              fillColor: "#e8faff",
              border: [false, false, false, false],
              bold: true,
            },
          ],
          ...graphicPageFor,
        ],
      },
      layout: {
        fillColor: function (rowIndex: any) {
          return rowIndex % 2 === 0 ? null : "#dee2e6";
        },
        defaultBorder: false,
        alignment: "center",
      },
    },
    {
      text: [{ text: "\n" }],
    },
    {
      style: "tableExample",
      table: {
        widths: [20, 175, 20, 175, 20, 175],
        heights: 0,
        body: [
          [
            {
              fillColor: "#6faf56",
              margin: [0, 0, 0, 0],
              text: "",
            },
            {
              text: t("global.adequate"),
              color: "#444",
              margin: [0, 0, 0, 0],
              fontSize: 10,
            },
            {
              fillColor: "#eed05a",
              margin: [0, 0, 0, 0],
              text: "",
            },
            {
              text: t("global.improvement_opportunity"),
              color: "#444",
              margin: [0, 0, 0, 0],
              fontSize: 10,
            },
            {
              fillColor: "#f75b5d",
              margin: [0, 0, 0, 0],
              text: "",
            },
            {
              text: t("global.attention_point"),
              margin: [0, 0, 0, 0],
              color: "#444",
              fontSize: 10,
            },
          ],
        ],
      },
      layout: {
        defaultBorder: false,
      },
    },
    {
      text: [
        {
          text:
            "\n\n" +
            t("global.report_page_for_text_01") +
            "\n\n" +
            t("global.report_page_for_text_02") +
            "\n\n",
          fontSize: 10,
        },
        {
          text: DataTests[_selectedJourney].can_improve_description.map(
            (desc: any) => {
              return {
                text: [
                  {
                    text: t(`tests.${desc}`) + "\n",
                    fontSize: 10,
                    bold: true,
                  },
                  {
                    text: t(`tests.${desc}_descricao`) + "\n\n",
                    fontSize: 9,
                  },
                ],
              };
            }
          ),
          fontSize: 30,
        },
      ],
      // pageBreak: "after",
    },
  ];
  // const pageFive: any = [
  //   {
  //     text: {
  //       text: t("global.conclusion") + "\n\n",
  //       fontSize: 14,
  //       bold: true,
  //     },
  //   },
  //   {
  //     text: [
  //       DataTests[_selectedJourney].evolution.length === 1
  //         ? t("global.report_page_five_text_01")
  //         : DataTests[_selectedJourney].evolution.length > 1
  //         ? t("global.report_page_five_text_02")
  //         : null,
  //       DataTests[_selectedJourney].evolution.length >= 1
  //         ? {
  //             text: `${DataTests[_selectedJourney].evolution.map((desc: any) =>
  //               t(`tests.${desc.test_name}`)
  //             )}.\n\n`,
  //             bold: true,
  //           }
  //         : null,
  //       DataTests[_selectedJourney].can_improve.length === 1
  //         ? t("global.report_page_five_text_03")
  //         : DataTests[_selectedJourney].can_improve.length > 1
  //         ? t("global.report_page_five_text_04")
  //         : null,
  //       DataTests[_selectedJourney].can_improve.length >= 1
  //         ? {
  //             text: `${DataTests[_selectedJourney].can_improve.map(
  //               (desc: any) => t(`tests.${desc.test_name}`)
  //             )}.`,
  //             bold: true,
  //           }
  //         : null,
  //       DataTests[_selectedJourney].can_improve.length === 1
  //         ? t("global.report_page_five_text_05") + "\n"
  //         : DataTests[_selectedJourney].can_improve.length > 1
  //         ? t("global.report_page_five_text_06") + "\n"
  //         : null,
  //       t("global.report_page_five_text_07") + "\n\n",
  //       DataTests[_selectedJourney].involution.length === 1
  //         ? t("global.report_page_five_text_08")
  //         : DataTests[_selectedJourney].involution.length > 1
  //         ? t("global.report_page_five_text_09")
  //         : null,
  //       DataTests[_selectedJourney].involution.length >= 1
  //         ? {
  //             text: `${DataTests[_selectedJourney].involution.map((desc: any) =>
  //               t(`tests.${desc.test_name}`)
  //             )}. `,
  //             bold: true,
  //           }
  //         : null,
  //       {
  //         text:
  //           DataTests[_selectedJourney].involution.length >= 1
  //             ? t("global.report_page_five_text_10")
  //             : null,
  //       },
  //     ],
  //     style: { fontSize: 10 },
  //   },
  // ];

  function rodape(currentPage: any, pageCount: any) {
    return [
      {
        text: currentPage + "/" + pageCount,
        alignment: "right",
        fontSize: 9,
        margin: [0, 10, 20, 0],
      },
    ];
  }
  // const docDefinitions: {
  //     pageSize: string;
  //     pageMargins: number[];
  //     header: {
  //         style: string;
  //         table: any;
  //     };
  //     content: any[];
  //     footer: (currentPage: any, pageCount: any) => {
  //         text: string;
  //         alignment: string;
  //         fontSize: number;
  //         margin: number[];
  //     }[];
  //     styles: {
  //         ...;
  //     };
  // }
  const docDefinitions = {
    pageSize: { width: 595.28, height: 841.89 },
    pageMargins: [15, 60, 15, 15] as [
      number,
      number,
      number,
      number
    ],
    header: {
      style: "headerStyle",
      table: reportTitle[0].table,
    },
    content: [
      pageOne,
      DataTests[_selectedJourney].evolution.length >= 1 ? pageTwo : null,
      DataTests[_selectedJourney].involution.length >= 1 ? pageThree : null,
      DataTests[_selectedJourney].can_improve.length >= 1 ? pageFor : null,
      // pageFive,
    ],
    footer: function (currentPage: any, pageCount: any) {
      return {
        text: currentPage.toString() + '/' + pageCount,
      };
    },
    styles: {
      headerStyle: {
        margin: [10, 10, 10, 10] as [number, number, number, number], // 10 pontos de margem superior
      },
      subheader: {
        fontSize: 15,
        bold: true,
      },
      small: {
        fontSize: 8,
      },
    },
  };
  pdfMake
    .createPdf(docDefinitions)
    .download(`Relatório_Final_${NameUser.replace(/\./g, "")}`);
}
